<template>
  <div class="nav-item dropdown">
    <a
      class="nav-link dropdown-toggle d-flex align-items-center"
      data-toggle="dropdown"
      href="#"
      role="button"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <span v-if="network">{{ network.type | title }}</span>
      <span v-else>None</span>
    </a>
    <div class="dropdown-menu dropdown-menu-right">
      <network-item
        v-for="companyNetwork in networks"
        :key="companyNetwork.id"
        :network="companyNetwork"
        :active="network"
        @networkChanged="updateNetwork"
      />
    </div>
  </div>
</template>
<script>
import NetworkItem from "./networkItem";

const emptyNetwork = { id: null, type: "None" };

export default {
  props: {
    dataNetworks: { type: Array },
    agent: { type: Object, required: true },
  },
  components: { NetworkItem },
  data() {
    return {
      network: this.agent.network || emptyNetwork,
    };
  },
  computed: {
    networks() {
      // add an empty network
      return this.dataNetworks.concat(emptyNetwork);
    },
  },
  methods: {
    updateNetwork(network) {
      // Update the network before the request is complete do that the user doesn't
      // wait for the network update
      this.network = network;

      this.$http
        .put(`api/v1/companyAgentClient/${this.agent.id}`, {
          network_id: network.id,
        })
        .catch(() => {
          // reset the  current network
          this.network = this.agent.network || emptyNetwork;
        });
    },
  },
};
</script>
